import React from 'react';
import { useDispatch } from 'react-redux';
import { ymcaLoginAction } from './YmcaLoginAction';
import { ActionType } from '../../core/redux/actionType';
import { Route, useLocation } from 'react-router-dom';
import { parseQueryToKeyedStrings } from '../../navigation/module';
import { useError, useLoading } from '../../core/api/hooks';
import { useAppState } from '../../core/redux/hooks';
import { useMount } from '../../core/hooks/useMount';


type Props = {
  className?: string;
};

type queryProps = {
  projectid?: string;
  returnURL?: string;
};


const YmcaLoginPage: React.FC<Props> = props => {
  const dispatch = useDispatch();

  const location = useLocation();
  const queryObj = parseQueryToKeyedStrings<queryProps>(location.search);

  const loginError  = !!useError(ActionType.YmcaLoginRequest);
  const isLoggingIn = useLoading(ActionType.YmcaLoginRequest);
  const ymcaSso     = useAppState(state => state.auth.ssoRedirect);

  useMount(() => { dispatch(ymcaLoginAction(queryObj.projectid, queryObj.returnURL)); });

  return (
    <div>
      {
        isLoggingIn && (
          <div>Redirecting...</div>
        )
      }
      {
        loginError && (
          <div>Error</div>
        )
      }
      {
        !!ymcaSso && (
          <Route path='/' render={() => (window.location.href = ymcaSso.redirectUrl)} />
        )
      }
    </div>
  );
};

export default YmcaLoginPage;
